// We define the routes in our app here
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Accommodatie from "../views/Accommodatie.vue";
import NoMenus from "../views/NoMenus.vue";
import Login from "../views/Login.vue";
import Profile from "../views/Profile.vue";
import Admin from "../views/Admin.vue";
import Attribute from "../views/Attribute.vue";
import Todo from "../views/Todo.vue";
import Help from "../views/Help.vue";

import AccommodatieHome from "../components/Accommodatie/AccommodatieHome.vue";
import AddAccommodatie from "../components/Accommodatie/AddAccommodatie.vue";
import MoveToSportcomplex from "../components/Accommodatie/MoveToSportcomplex.vue";
import VoorzieningHome from "../components/Accommodatie/Voorziening/VoorzieningHome.vue";
import AddVoorziening from "../components/Accommodatie/Voorziening/AddVoorziening.vue";
import SportcomplexHome from "../components/Accommodatie/Sportcomplex/SportcomplexHome.vue";
import DomeinlijstOverview from "../components/Domeinlijst/DomeinlijstOverview.vue";
import EditFlexPropsSchema from "../components/Domeinlijst/EditFlexPropsSchema.vue";
import DownloadExport from "../components/DownloadExport.vue";
import PublicExport from "../components/SearchResults/PublicExport.vue";
import TodoSearchResults from "../components/TodoSearch/SearchResults.vue";
import HelpMain from "../components/Help/HelpMain.vue";
import ExportVoorwaarden from "../components/Help/ExportVoorwaarden.vue";
import ExportStructure from "../components/Help/ExportStructure.vue";
import HelpFlexprops from "../components/Help/HelpFlexprops.vue";

import Roles from "../components/Admin/Roles.vue";
import Users from "../components/Admin/Users.vue";
import EditUser from "../components/Admin/EditUser";
import NotFound from "../components/Errors/NotFound.vue";

import SetPassword from "../components/Auth/SetPassword.vue";
import ForgotPassword from "../components/Auth/ForgotPassword.vue";

import store from "../store/store.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: checkAuth
  },
  {
    path: "/download/file/:dlid",
    name: "Download",
    component: DownloadExport
  },
  {
    path: "/wachtwoordinstellen/:token",
    name: "SetPassword",
    component: SetPassword
  },
  {
    path: "/forgot",
    name: "ForgotPassword",
    component: ForgotPassword
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/attributes/",
    component: Attribute,
    name: "Attribute",
    meta: { permission: "update domeinlijst" },
    beforeEnter: checkAuth,
    children: [
      {
        path: "domeinlijsten/:name",
        name: "EditDomeinlijsten",
        component: DomeinlijstOverview,
        meta: { permission: "update domeinlijst" },
        beforeEnter: checkAuth
      },
      {
        path: "domeinlijsten/voorziening_typen/:id/flexprops",
        name: "EditFlexpropSchema",
        component: EditFlexPropsSchema,
        meta: { permission: "update domeinlijst" },
        beforeEnter: checkAuth
      }
    ]
  },
  {
    path: "/accommodatie/:id",
    component: Accommodatie,
    meta: { permission: "read accommodatie" },
    beforeEnter: checkAuth,
    children: [
      {
        path: "",
        name: "Accommodatie",
        component: AccommodatieHome,
        meta: { permission: "read accommodatie" }
      },
      {
        path: "voorziening/:vzid",
        name: "Voorziening",
        component: VoorzieningHome,
        meta: { permission: "read accommodatie" },
        beforeEnter: checkAuth
      },
      {
        path: "addvoorziening/",
        name: "AddVoorziening",
        component: AddVoorziening,
        beforeEnter: checkAuth
      },
      {
        path: "sportcomplex",
        name: "Sportcomplex",
        component: SportcomplexHome,
        meta: { permission: "read accommodatie" },
        beforeEnter: checkAuth
      },
      {
        path: "move_to_sportcomplex",
        name: "MoveToSportcomplex",
        component: MoveToSportcomplex,
        meta: { permission: "update accommodatie" },
        beforeEnter: checkAuth
      }
    ]
  },
  {
    path: "/add/",
    component: NoMenus,
    beforeEnter: checkAuth,
    children: [
      {
        path: "accommodatie",
        name: "AddAccommodatie",
        component: AddAccommodatie,
        beforeEnter: checkAuth
      }
    ]
  },
  {
    path: "/public/",
    component: NoMenus,
    beforeEnter: checkAuth,
    children: [
      {
        path: "export",
        name: "PublicExport",
        component: PublicExport,
        beforeEnter: checkAuth
      }
    ]
  },
  {
    path: "/todo",
    component: Todo,
    beforeEnter: checkAuth,
    children: [
      {
        path: "",
        name: "TodoSearchResults",
        component: TodoSearchResults
      }
    ]
  },
  {
    path: "/help",
    component: Help,
    beforeEnter: checkAuth,
    children: [
      {
        path: "",
        name: "HelpMain",
        component: HelpMain
      },
      {
        path: "voorwaarden",
        name: "ExportVoorwaarden",
        component: ExportVoorwaarden
      },
      {
        path: "structuurexport",
        name: "ExportStructure",
        component: ExportStructure
      },
      {
        path: "flexprops",
        name: "HelpFlexprops",
        component: HelpFlexprops
      }
    ]
  },
  {
    path: "/admin/",
    component: Admin,
    name: "Admin",
    meta: { permission: "access admin pages" },
    beforeEnter: checkAuth,
    children: [
      {
        path: "roles",
        name: "EditRoles",
        component: Roles,
        meta: { permission: "access admin pages" },
        beforeEnter: checkAuth
      },
      {
        path: "users",
        name: "EditUsers",
        component: Users,
        meta: { permission: "access admin pages" },
        beforeEnter: checkAuth
      },
      {
        path: "user/:id",
        name: "EditUser",
        component: EditUser,
        meta: { permission: "access admin pages" },
        beforeEnter: checkAuth
      }
    ]
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    beforeEnter: checkAuth
  },
  {
    path: "/404",
    component: NotFound
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  },
  base: process.env.BASE_URL,
  routes
});

function checkAuth(to, from, next) {
  const authenticated = store.getters.current_user;
  const has_permission = to.meta.permission
    ? store.state.user.permissions.includes(to.meta.permission)
    : true;
  if (authenticated && has_permission) {
    next();
  } else if (!authenticated) {
    next("/login");
  } else {
    // authenticated but no permission
    next(false);
  }
}

export default router;
